import React from 'react';
import ModalContent from 'src/formcontrols/hoc/PopupModal/ModalContent';
import { ComponentType } from 'src/formcontrols/hoc/PopupModal/ModalEnum';
import ModalFooter from 'src/formcontrols/hoc/PopupModal/ModalFooter';
import ModalHeader from 'src/formcontrols/hoc/PopupModal/ModalHeader';
import PopupModal from 'src/formcontrols/hoc/PopupModal/PopupModal';
import 'src/formcontrols/Modals/EditModal/EditModal.css';
import * as ColorPalette from 'src/formcontrols/Themes/theme';

interface IProps {
  isModalOpen: boolean;
  isLoading: boolean;
  modalHeader: string;
  onSave: any;
  onCloseModal?: any;
  footerText?: string;
  showSaveBtn?: boolean;
  style?: any;
}

const editModalStyle = {
  background: ColorPalette.colors.bgDark,
  color: ColorPalette.colors.text,
  fontSize: '14px',
  width: '100%',
};

export const EditModal: React.StatelessComponent<IProps> = props => {
  const editStyle = { ...editModalStyle, ...props.style };
  return (
    <PopupModal isModalOpen={props.isModalOpen}>
      <div className="edit-modal" style={editStyle}>
        <div>
          <ModalHeader
            isComponentLoading={props.isLoading}
            componentHeader={props.isLoading ? '' : props.modalHeader}
            onCloseClicked={props.onCloseModal}
            onPrintClicked={props.onCloseModal}
            componentType={ComponentType.Edit}
          />
        </div>
        <div className="edit-modal-content">
          <ModalContent isLoading={props.isLoading}>{props.children}</ModalContent>
        </div>
        <div>
          <ModalFooter
            isComponentLoading={props.isLoading}
            onCancelClicked={props.onCloseModal}
            onOperatioConfirmed={props.onSave}
            componentType={ComponentType.Edit}
            showOperationConfirmedBtn={props.showSaveBtn}
            footerText={props.footerText}
          />
        </div>
      </div>
    </PopupModal>
  );
};
